// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"110":"bffa7eb6e6517c64","418":"97960c46015b6ad0","627":"d2c725e9a78501ce","833":"9aebdc760967e253"}[chunkId] + ".css";
};